<script>
// import TestLayouts from '@store/TestLayouts'
import { mapActions, mapGetters } from 'vuex'
import RetriesLoadOnDisplay from '@mixins/retries-load-on-display'

export default {
  name: 'WithLayout',
  mixins: [RetriesLoadOnDisplay],
  props: {
    slug: {
      type: [String, Boolean],
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLayoutLoading: false,
    }
  },
  computed: {
    ...mapGetters('layouts', ['getLayoutBySlug', 'getLayout']),
    theLayout() {
      if (this.isLayoutLoading) return false
      return this.cachedLayout
    }, // theLayout
    cachedLayout() {
      if (this.slug) {
        return this.getLayoutBySlug(this.slug)
      } else if (this.id) {
        return this.getLayout(this.id)
      } else {
        return false
      }
    }, // cachedLayout
    regions() {
      return this.theLayout.regions || []
    }, // regions
  },
  watch: {
    slug: {
      async handler(val) {
        this.isLayoutLoading = true
        await this.loadLayout()
        this.isLayoutLoading = false
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions('layouts', ['fetchLayoutBySlug', 'fetchLayout']),
    async loadLayout() {
      let result
      if (this.slug) {
        result = await this.fetchLayoutBySlug({
          layoutSlug: this.slug || this.$route.params.layoutSlug,
        })
      }
      if (this.id) {
        result = await this.fetchLayout({
          layoutId: this.id,
        })
      }
      // Both actions resolve with the error when the request fails. A 404 tries
      // again too, since the layout may only be missing for now
      if (result && !this.cachedLayout) {
        this.retryLoadOnDisplay(this.loadLayout)
      }
    },
  },
  render() {
    return this.$scopedSlots.default({
      theLayout: this.theLayout,
      isLayoutLoading: this.isLayoutLoading,
      regions: this.regions,
    })
  },
}
</script>
